import React,{useState} from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './Hero';
import AssessmentSection from './AssessmentSection';
import TestCards from './TestCards';
import TrackProgress from './TrackProgress';
import CandidateTable from './CandidateTable';
import Footer from '../About/Footer';
import Navbar from '../About/Navbar';
import CandidateList from './CandidateList';
import {ScheduleTest} from '../Screening/Popup/ScheduleTest';
import { cn } from '@/lib/utils';

function EvaluatorHome() {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedTestCard, setSelectedTestCard] = useState(null);
  const [showScheduleTestPopup, setShowScheduleTestPopup] = useState(false);

  // Parse jobId from the URL query string
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const jobId = queryParams.get('jobID');

  const handleSelectCandidate = (users) => {
    setSelectedUsers(users);
  };

  const handleSelectTestCard = (card) => {
    setSelectedTestCard(card);
    setShowScheduleTestPopup(true);
  };

  const handleCloseScheduleTestPopup = () => {
    setShowScheduleTestPopup(false);
  };
  return (
    <div className={cn("min-h-screen w-full bg-background")}>
      <TestCards onSelectTestCard={handleSelectTestCard} />
      {showScheduleTestPopup && (
        <ScheduleTest
          onClose={handleCloseScheduleTestPopup}
          selectedUsers={selectedUsers}
          selectedTestCard={selectedTestCard}
          jobId={jobId}
        />
      )}
    </div>
  );
}

export default EvaluatorHome;